<div class="col-md-12 row mt-3" >
  <div *ngIf="retrive==='terminal'" class="col-md-10 " >
<div class="terminal" (click)="focusTerminal()">

  <div class="output " *ngFor="let item of terminalItems">
    <span *ngIf=' item.type === "command"' class="command">
      <pre> > {{ item.text }}</pre>
      
    </span>
    <span *ngIf=' item.type === "output"' class="output">
      <pre> {{ item.text }}</pre>
      
    </span>
  </div>
  
 
 <!-- <input type="text" (keydown.enter)="executeCommand($event.target.value)">-->
</div>
<div class="terminal-input col-md-12 " (click)="focusTerminal()">
  <span class="prompt col-md-1">></span>
  <input *ngIf="!showPending" class="col-md-11" type="text" [(ngModel)]="command" name="terminal" id="terminal" #terminal autofocus (keyup.enter)="executeCommand($event)"  />
 <span *ngIf="showPending" style="padding-left: 100px;">
  <div class=" pending-icon"></div>
  <!-- To create the backward movement, add the 'reverse' class -->
  <div class=" pending-icon reverse"></div>
</span>
 
</div>

</div>
<div *ngIf="retrive==='ticket-issuance'" class="col-md-10 ">
  <app-ticket-issuance></app-ticket-issuance>
</div>
<div *ngIf="retrive==='progress'" class="col-md-10 ">
  <app-work-in-progress></app-work-in-progress>
</div>

<div class="col-md-2 pt-4">    
  
  <span  class="col-md-12"><button class="btn mb-3" (click)="commandClick('back')" >	<mat-icon>keyboard_backspace</mat-icon></button></span>

  <span *ngIf="retrive!='terminal'" class="col-md-12"><button class="btn mb-3" (click)="commandClick('terminal')" >Terminal</button></span>

   <span class="col-md-12"><button class="btn" (click)="commandClick('ticket-issuance')" >Retrive PNR</button></span>

  <span class="col-md-12"><button class="btn mt-3" (click)="commandClick('ticket-issuance')" >Ticket Issuance</button></span>
  <span class="col-md-12"><button class="btn mt-3" (click)="commandClick('flight')" >PNR Creation</button></span>
  <span class="col-md-12"><button class="btn mt-3" (click)="commandClick('flight')" >Availability Check</button></span>
  <span class="col-md-12"><button class="btn mt-3" (click)="commandClick('progress')" >Cancel Ticket</button></span>
  <span class="col-md-12"><button class="btn mt-3" (click)="commandClick('progress')" >ReIssue Ticket</button></span>
  
  
  <div *ngIf="retrive==='terminal'" style="margin-top: 30%;">
  <span  class="col-md-12 " ><button class="btn mt-3" (click)="commandClick('clear')">Clear</button></span>
  <span class="col-md-12"><button (click)="commandClick('history')"  class="btn mt-3">History</button></span>
  </div>
</div>
</div>
